const DEFAULT_WIDGET_LABELS = {
  player_ranking: 'Statistiques joueurs',
  team_ranking: 'Statistiques équipes',
  team_standings: 'Classement',
  competition_results: 'Résultats',
  direct_calendar: 'Directs',
};

export const getSingleCompetitionName = (competitionInfos = []) => {
  return competitionInfos.length === 1 ? competitionInfos[0]?.name || '' : '';
};

export const buildDefaultWidgetTitle = ({
  widgetConfig,
  competitionInfos = [],
  fallbackTitle = '',
}) => {
  const widgetType = widgetConfig?.widgetType || '';
  const widgetLabel = DEFAULT_WIDGET_LABELS[widgetType] || fallbackTitle || '';
  const competitionName = getSingleCompetitionName(competitionInfos);
  const isComposed = widgetType === 'composed_tabs';

  if (isComposed) {
    return competitionName || fallbackTitle || widgetLabel;
  }

  if (competitionName) {
    if (widgetType === 'direct_calendar'){
      return `${competitionName}`;
    }
    return `${widgetLabel} - ${competitionName}`;
  }

  return widgetLabel || fallbackTitle || '';
};

export const resolveWidgetDisplayTitle = ({
  widgetConfig,
  competitionInfos = [],
  fallbackTitle = '',
}) => {
  const mode = widgetConfig?.displayTitleMode ?? 'default';

  if (mode === 'none') return '';

  if (mode === 'custom') {
    return String(widgetConfig?.displayTitle || '').trim();
  }

  return buildDefaultWidgetTitle({
    widgetConfig,
    competitionInfos,
    fallbackTitle,
  });
};